import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PageTransition } from "../components/ui/PageTransition";

export function NotFoundPage(): ReactNode {
  return (
    <main className="not-found-page">
      <PageTransition>
        <div className="not-found-code">404</div>
        <h1>Page not found</h1>
        <p>The page you are looking for does not exist.</p>
        <Link to="/">Go home</Link>
      </PageTransition>
    </main>
  );
}
